
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 501 570"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M175.2 67.5c-10 2.8-18.1 10.5-21.3 20.2-1.7 5.3-.7 17 1.9 22.4 1.7 3.5 23 25.3 84.7 86.8l82.5 82.2-82.5 82c-62 61.7-83 83.2-84.7 86.7-1.6 3.4-2.4 6.9-2.6 12.7-.4 7.5-.2 8.4 3 14.5 7.8 15 25 20.7 40.7 13.5 4.4-2.1 20.4-17.6 99.6-96.6 105.8-105.5 98.9-97.6 98.9-112.9 0-15.3 7-7.4-98.9-112.8C194.7 64.7 197.9 67.6 186 66.5c-3.4-.3-7.6.1-10.8 1z","fill":"#CF0209"}})])
          )
        }
      }
    